import { Component } from '@angular/core';

@Component({
    selector: 'upp-application-menu',
    templateUrl: './upp-menu.html',
    styleUrls: ['./upp-menu.scss'],
})
export class UppApplicationMenuComponent {
    // nothing to do
}
